import React from 'react';
import { Sparkles } from 'lucide-react';
import { SectionWrapper } from './shared/SectionWrapper';
import { CTAButton } from './shared/CTAButton';
export function WorkGallery() {
  const works = [{
    title: 'Cutícula',
    desc: 'terminación limpia de estudio'
  }, {
    title: 'Perfil',
    desc: 'estructura + apex bien construido'
  }, {
    title: 'Terminación',
    desc: 'brillo y sellado parejo'
  }, {
    title: 'Baby',
    desc: 'degradé prolijo y vendible'
  }];
  return <SectionWrapper bg="cream" data-id="element-312">
      <div className="max-w-5xl mx-auto text-center" data-id="element-313">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-4" data-id="element-314">
          No te lo prometemos: te lo mostramos
        </h2>
        <p className="text-lg text-warm-muted mb-12" data-id="element-315">
          Son <strong data-id="element-316">nuestros trabajos reales</strong>, con la técnica tal como
          se enseña en el programa:
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-317">
          {works.map((work, idx) => <div key={idx} className="bg-white rounded-2xl overflow-hidden shadow-soft border border-blush flex flex-col" data-id="element-318">
              {/* Image Placeholder */}
              <div className="aspect-square bg-gradient-to-br from-blush to-rose/10 flex items-center justify-center relative group" data-id="element-319">
                <Sparkles className="w-12 h-12 text-rose/30 group-hover:scale-110 transition-transform duration-500" data-id="element-320" />
                <div className="absolute inset-0 bg-black/5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-321">
                  <span className="bg-white/90 text-warm-dark text-xs font-bold px-3 py-1 rounded-full" data-id="element-322">
                    Trabajo Real
                  </span>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center" data-id="element-323">
                <h3 className="font-serif font-bold text-lg text-rose mb-1" data-id="element-324">
                  {work.title}
                </h3>
                <p className="text-warm-muted text-sm leading-snug" data-id="element-325">
                  — {work.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-white p-6 md:p-8 rounded-2xl border border-rose/20 shadow-sm inline-block max-w-2xl mx-auto mb-10" data-id="element-326">
          <p className="text-xl font-serif font-bold text-warm-dark" data-id="element-327">
            Si tus sets no se ven así de consistentes, tu precio se te queda
            corto.
          </p>
        </div>

        <div data-id="element-328">
          <CTAButton variant="primary" scrollTo="comprar" data-id="element-329">
            SÍ, QUIERO ESA TERMINACIÓN
          </CTAButton>
        </div>
      </div>
    </SectionWrapper>;
}